import React, { useState } from "react";
import { signupReq } from "./fetchApi";
import toast from "react-hot-toast";

const Signup = ({ colors, changeMode }) => {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    cPassword: "",
    loading: false,
  });

  const { name, email, password, cPassword, loading } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) return toast.error("Định dạng email không hợp lệ!");
    if (password.length < 8) return toast.error("Mật khẩu phải chứa ít nhất 8 ký tự!");
    if (password !== cPassword) return toast.error("Mật khẩu xác nhận không khớp!");

    setData({ ...data, loading: true });
    try {
      const res = await signupReq({ name, email, password, cPassword });
      if (res && res.success) {
        toast.success("Tạo tài khoản thành công! Vui lòng đăng nhập.");
        setTimeout(() => { changeMode(); }, 1500);
      } else {
        toast.error(res?.error || "Đăng ký thất bại!");
        setData({ ...data, loading: false });
      }
    } catch (err) {
      toast.error("Lỗi kết nối máy chủ!");
      setData({ ...data, loading: false });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="small fw-bold mb-2 d-block" style={{ color: colors.textMain }}>Họ và Tên</label>
        <input type="text" name="name" value={name} onChange={handleChange}
          className="form-control auth-input w-100" placeholder="Nguyễn Văn A" required />
      </div>

      <div className="mb-3">
        <label className="small fw-bold mb-2 d-block" style={{ color: colors.textMain }}>Email liên hệ</label>
        <input type="email" name="email" value={email} onChange={handleChange}
          className="form-control auth-input w-100" placeholder="name@handdn.com" required />
      </div>

      <div className="row g-3 mb-4">
        <div className="col-6">
          <label className="small fw-bold mb-2 d-block" style={{ color: colors.textMain }}>Mật khẩu</label>
          <input type="password" name="password" value={password} onChange={handleChange}
            className="form-control auth-input w-100" placeholder="Min 8 ký tự" required />
        </div>
        <div className="col-6">
          <label className="small fw-bold mb-2 d-block" style={{ color: colors.textMain }}>Xác nhận</label>
          <input type="password" name="cPassword" value={cPassword} onChange={handleChange}
            className="form-control auth-input w-100" placeholder="••••••••" required />
        </div>
      </div>

      <button disabled={loading} type="submit" className="auth-btn w-100">
        {loading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        ) : (
          "TẠO TÀI KHOẢN MỚI"
        )}
      </button>
    </form>
  );
};

export default Signup;